import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { swipeImageDomainWhitelistPattern } from './swipe';

export type SimpleSignupConfigType = Static<typeof SimpleSignupConfigSchema>;
export const SimpleSignupConfigSchema = Type.Object(
  {
    // Empty object for now
  },
  { additionalProperties: false, $id: 'SimpleSignupConfigSchema' }
);

export type SimpleSignupTranslation = Static<typeof SimpleSignupTranslationSchema>;
export const SimpleSignupTranslationSchema = Type.Object(
  {
    title: Type.String({
      minLength: 1,
      maxLength: 100,
    }),
    body: Type.String({
      minLength: 1,
      maxLength: 1600,
    }),
    image: Type.String({
      format: 'uri',
      maxLength: 1000,
      pattern: swipeImageDomainWhitelistPattern,
    }),
  },
  { additionalProperties: false, $id: 'SimpleSignupTranslationSchema' }
);
